/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Action_Deactivate2Inputs */

const en_settings_reportingapikeys_action_deactivate2 = /** @type {(inputs: Settings_Reportingapikeys_Action_Deactivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate`)
};

/**
* | output |
* | --- |
* | "Deactivate" |
*
* @param {Settings_Reportingapikeys_Action_Deactivate2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_action_deactivate2 = /** @type {((inputs?: Settings_Reportingapikeys_Action_Deactivate2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Action_Deactivate2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_action_deactivate2(inputs)
});
export { settings_reportingapikeys_action_deactivate2 as "settings_reportingApiKeys_action_deactivate" }